import type { ReactNode } from 'react'

interface PageHeaderProps {
  /** Page title */
  title: string
  /** Optional subtitle or description */
  description?: string
  /** Action buttons or other elements to display on the right */
  actions?: ReactNode
}

/**
 * Consistent page header with title and optional actions.
 */
export function PageHeader({ title, description, actions }: PageHeaderProps) {
  return (
    <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
      <div>
        <h1 className="text-2xl font-bold tracking-tight text-foreground">
          {title}
        </h1>
        {description && (
          <p className="mt-1 text-sm text-muted-foreground">{description}</p>
        )}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  )
}
